<template>
  <main class="home">
    <h1>Home</h1>
    <br />
    <p>Congratulations, you are logged in!</p>
  </main>
</template>
